
// #region imports

// --- Angular
import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';

// #endregion

@Directive({
  selector: '[hsScrollToError]'
})
export class ScrollToErrorDirective implements AfterViewInit {

  @Input() hsScrollToError: string;
  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    this.scrollToError();
  }

  scrollToError() {
    const { nativeElement } = this.elementRef;
    window.scroll({ top: this.getElementOffset(nativeElement) - window.innerHeight / 2, behavior: 'smooth' });
  }

  private getElementOffset(element: any) {
    return element.offsetTop + ( element.offsetParent ? element.offsetParent.offsetTop : 0 );
  }
}
